module.exports = __webpack_public_path__ + "img/top-menu-title.b25f9865.svg";